import { render, staticRenderFns } from "./consegne.vue?vue&type=template&id=d1db239e&"
import script from "./consegne.vue?vue&type=script&lang=js&"
export * from "./consegne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports